import {
  createCatalogEndpoint,
  createCrudEndpoints,
  createExportEndpoint,
} from '@/core/utils'
import { TInventory, TInventoryHistory } from '.'
import {
  DataWithPagination,
  SummaryStocks,
  TBaseCatalogs,
  TBaseWarehouse,
  TFilters,
} from '@/core/types'
import { TArticle } from '../purchase-orders'
import api from '@/core/config/axios'
import { MaybeRef, toValue } from 'vue'
import { TMill } from '../mills'

export type TInventories = DataWithPagination<TInventory>
export type TInventoryHistories = DataWithPagination<TInventoryHistory>
type NestedParams = {
  modelId?: MaybeRef<number | string>
  modelChildId?: MaybeRef<number | string>
}
export const serviceConfig = {
  model: 'stock',
  version: 'v1',
  details: {
    model: 'details',
    version: 'v1',
  },
  catalogs: {
    warehouse: {
      model: 'warehouses',
      version: 'v1',
    },
    articles: {
      model: 'articles',
      version: 'v1',
    },
    categories: {
      model: undefined,
      version: 'v1',
    },
    mills: {
      model: 'mills',
      version: 'v1',
    },
  },
}

const { warehouse, articles, categories, mills } = serviceConfig.catalogs

const moduleServiceHandlers = {
  ...createCrudEndpoints<TInventories, TInventory>(
    serviceConfig.model,
    serviceConfig.version,
  ),
  loadSummary: async (params: TFilters): Promise<SummaryStocks> => {
    const urlSearchParams = [
      `page=${toValue(params.page) ?? 1}`,
      toValue(params.dynamicFilters ?? ''),
    ]
      .filter(Boolean)
      .join('&')
    return api
      .get(
        `${serviceConfig.version}/${serviceConfig.model}/summary?${urlSearchParams}`,
      )
      .then((response) => response.data)
  },
  loadDetails: async (
    params: TFilters & NestedParams,
  ): Promise<TInventoryHistories> => {
    return api
      .get(
        `${serviceConfig.version ?? ''}/${serviceConfig.model}/${toValue(
          params.modelId,
        )}/${serviceConfig.details.model}?page=${toValue(params.page ?? 1)}`,
      )
      .then((response) => response.data)
  },
}
const warehouseCatalog = createCatalogEndpoint<TBaseWarehouse[]>(
  warehouse.model,
  warehouse.version,
)

const articlesCatalog = createCatalogEndpoint<TArticle[]>(
  articles.model,
  articles.version,
)

const categoriesCatalog = createCatalogEndpoint<TBaseCatalogs>(
  categories.model,
  categories.version,
)

const millsCatalog = createCatalogEndpoint<TMill[]>(mills.model, mills.version)

const moduleExportHandlers = createExportEndpoint(serviceConfig.model)

const catalogServiceHandlers = {
  warehouseCatalog,
  articlesCatalog,
  categoriesCatalog,
  millsCatalog,
}

export { moduleServiceHandlers, moduleExportHandlers, catalogServiceHandlers }
